import * as React from 'react';
import ReactDOM from 'react-dom';
import { deepOrange } from '@mui/material/colors';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            //main: deepOrange[400],
            main: "#ef9341",
        },
    },
});

// function theme() {
//   return <ThemeProvider theme={theme}>...</ThemeProvider>;
// }

export default theme;